var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.navbar)?_c('NavBar'):_vm._e(),_c('router-view',{class:{'app-content': _vm.navbar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }